import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { EmployeePickerField } from "../../../../../common/selectComponents/EmployeePicker";
import { EmployeeTypePickerField } from "../../../../../common/selectComponents/EmployeeTypePicker";
import { DateInput, Input } from "../../../../../common/Input";
import { LoadingSpinner } from "../../../../../common/Loading";

const EmployeeTypeTaggingModal = ({ isOpen, onClose, onSave, loading, selectedData }) => {
  const [form, setForm] = useState({
    employeeId: "",
    employeeName: "",
    employeeTypeId: "",
    employeeTypeDescription: "",
    effectivityDate: new Date().toISOString().split('T')[0]
  });

  useEffect(() => {
    if (selectedData) {
      // MODIFIED: Ensure employeeTypeId is mapped so the picker can "see" the selection
      setForm({
        employeeId: selectedData.employeeId,
        employeeName: selectedData.employeeFullName,
        employeeTypeId: selectedData.employeeTypeId, // ADDED
        employeeTypeDescription: selectedData.employeeType,
        effectivityDate: selectedData.effectivityDate?.split('T')[0] || ""
      });
    } else {
      setForm({
        employeeId: "",
        employeeName: "",
        employeeTypeId: "",
        employeeTypeDescription: "",
        effectivityDate: new Date().toISOString().split('T')[0]
      });
    }
  }, [selectedData, isOpen]);

  if (!isOpen) return null;
  const isView = !!selectedData;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-4" style={{ marginTop: 0 }}>
      <div className="bg-white w-full max-w-lg rounded-lg shadow-2xl flex flex-col">
        <div className="flex justify-between items-center p-4 border-b bg-gray-50 rounded-t-lg">
          <h3 className="font-bold text-gray-700">{isView ? "View Tagging" : "Add Employee Type Tagging"}</h3>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer text-gray-400 hover:text-gray-600">
            <CloseIcon />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <Input
            label="Transaction Number"
            value={isView ? selectedData.transactionNumber : "--Auto Generate after Creation--"}
            disabled
          />

          <EmployeePickerField
            label="Employee"
            isRequired={true}
            employeePersonalInformationId={form.employeeId}
            displayValue={form.employeeName}
            onSelect={(emp) => setForm({ ...form, employeeId: emp.id, employeeName: emp.fullName })}
            viewMode={isView} // MODIFIED: using viewMode for consistent UI
          />

          <EmployeeTypePickerField
            label="Temp. Employee Type"
            isRequired={true}
            employeeTypeId={form.employeeTypeId}
            displayValue={form.employeeTypeDescription}
            onSelect={(type) => setForm({
              ...form,
              employeeTypeId: type.id,
              employeeTypeDescription: type.description || type.name
            })}
            viewMode={isView} // MODIFIED: using viewMode for consistent UI
          />

          <DateInput
            label="Effectivity Date"
            value={form.effectivityDate}
            onChange={(e) => setForm({ ...form, effectivityDate: e.target.value })}
            disabled={isView}
          />
        </div>

        <div className="flex justify-end gap-2 p-4 border-t bg-gray-50 rounded-b-lg">
          <button onClick={onClose} className="px-6 py-2 bg-gray-400 text-white rounded border-none cursor-pointer hover:bg-gray-500 transition-colors">
            Close
          </button>
          {!isView && (
            <button
              onClick={() => onSave(form)}
              disabled={loading || !form.employeeId || !form.employeeTypeId}
              className="px-6 py-2 bg-blue-600 text-white rounded border-none cursor-pointer font-bold hover:bg-blue-700 disabled:opacity-50 transition-colors"
            >
              {loading ? "Saving..." : "Save Tagging"}
            </button>
          )}
        </div>
      </div>
      <LoadingSpinner loading={loading} />
    </div>
  );
};

export default EmployeeTypeTaggingModal;